import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=695e1576&scoped=true&"
import script from "./projectDetail.vue?vue&type=script&lang=js&"
export * from "./projectDetail.vue?vue&type=script&lang=js&"
import style0 from "./projectDetail.vue?vue&type=style&index=0&id=695e1576&prod&lang=css&"
import style1 from "./projectDetail.vue?vue&type=style&index=1&id=695e1576&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695e1576",
  null
  
)

export default component.exports